<template>
  <div class="pic">
    <h2 style="text-transform: capitalize;">{{ message }}</h2>
    <el-tabs
      v-model="activeName"
      type="card"
      @tab-click="handleClick"
      class="tabs"
    >
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
      >
        <div class="images">
          <div class="image-section">
            <div
              v-for="(image, index) in currentImages"
              :key="index"
              class="images-wrapper"
            >
              <el-image
                :src="image.url"
                :alt="image.name"
                style="width: 100%; height: auto; margin: 30px"
                fit="cover"
                lazy
              ></el-image>
              <div style="font-size: 20px;position: absolute;top: 90%;;left: 46%;">{{ image.name }}</div>
            </div>
          </div>
        </div>
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tab.currentPage"
          :page-sizes="[10]"
          :page-size="tab.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tab.totalItems"
        >
        </el-pagination> -->
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  props: {
    message: String, // 定义接收一个名为 parentMessage 的 prop
  },
  data() {
    return {
      currentImages: [],
      activeName: "",
      tabs: [],
      MaizeTabs: [
        // 定义一个数组来存储每个标签页的信息
        {
          name: "PPI-Ear(Li et al. 2019)",
          label: "PPI-Ear(Li et al. 2019)",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-Ear(Sun et al. 2020)",
          label: "PPI-Ear(Sun et al. 2020)",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-Shoot(Li et al. 2019)",
          label: "PPI-Shoot(Li et al. 2019)",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-Shoot(Peng et al. 2019)",
          label: "PPI-Shoot(Peng et al. 2019)",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-Tassel(Sun et al. 2020)",
          label: "PPI-Tassel(Sun et al. 2020)",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-Ear(Li et al. 2019)",
          label: "PDI-Ear(Li et al. 2019)",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-Shoot(Li et al. 2019)",
          label: "PDI-Shoot(Li et al. 2019)",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-Shoot(Peng et al. 2019)",
          label: "PDI-Shoot(Peng et al. 2019)",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
      ],
      RiceTabs: [
        {
          name: "MH34",
          label: "MH34",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "MH39",
          label: "MH39",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "MHP2",
          label: "MHP2",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "ZS34",
          label: "ZS34",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "ZS39",
          label: "ZS39",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "ZSP2",
          label: "ZSP2",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
      ],
      CottonTabs: [
        {
          name: "PPI-A2",
          label: "PPI-A2",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-B1",
          label: "PPI-B1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-C1",
          label: "PPI-C1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-D5",
          label: "PPI-D5",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-E1",
          label: "PPI-E1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-F1",
          label: "PPI-F1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-G1",
          label: "PPI-G1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PPI-K2",
          label: "PPI-K2",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-A2",
          label: "PDI-A2",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-B1",
          label: "PDI-B1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-C1",
          label: "PDI-C1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-D5",
          label: "PDI-D5",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-E1",
          label: "PDI-E1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-F1",
          label: "PDI-F1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-G1",
          label: "PDI-G1",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI-K2",
          label: "PDI-K2",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
      ],
      WheatTabs: [
        {
          name: "PPI",
          label: "PPI",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
        {
          name: "PDI",
          label: "PDI",
          currentPage: 1,
          pageSize: 10,
          totalItems: 100,
        },
      ],
    };
  },
  mounted() {
    if (this.tabs.length > 0) {
      this.activeName = this.tabs[0].name; // 设置为第一个标签页的name
    }
  },
  created() {
    // this.getValidationImg(this.message, "ATATAA");
  },
  methods: {
    // handleSizeChange(newSize) {
    //   const tab = this.tabs.find((t) => t.name === tabName);
    //   if (tab) {
    //     tab.pageSize = newSize;
    //     this.loadImages(this.message); // 重新加载当前标签页的图片
    //   }
    // },
    // handleCurrentChange(newPage) {
    //   // 你可能需要以不同的方式获取当前激活的tab的名称，因为此处的函数签名已更改
    //   const tab = this.tabs.find((t) => t.name === this.activeName);
    //   if (tab) {
    //     tab.currentPage = newPage;
    //     this.loadImages(this.message); // 使用当前激活的tab重新加载图片
    //   }
    // },
    processActiveName(activeName) {
      // 检查activeName是否包含横杠
      if (activeName.includes("-")) {
        // 如果包含横杠，按横杠分割并返回分割的部分
        const parts = activeName.split("-");
        console.log(`Name contains dash, split into: ${parts.join(", ")}`);
        return parts; // 返回分割后的数组
      } else {
        // 如果不包含横杠，直接返回activeName
        console.log(`Name does not contain dash, original: ${activeName}`);
        return activeName; // 返回原始字符串
      }
    },
    async loadImages(project) {
      try {
        const currentTab = this.tabs.find(
          (tab) => tab.name === this.activeName
        );
        if (!currentTab) return; // 如果没有找到匹配的标签页，则不执行任何操作
        let page = currentTab.currentPage;
        let size = currentTab.pageSize;
        let result1 = this.processActiveName(this.activeName);
        // 处理activeName
        let res;
        if (Array.isArray(result1)) {
          // 结果是数组，处理分割后的部分
          let [part1, part2] = result1;
          // 小写转换
          part1 = part1.toLowerCase()
          res = await this.$API.reqResMotifsImg(
            project,
            part1,
            part2
            // page,
            // size
          );
        } else if (result1 === "PPI" || result1 === "PDI") {
          // wheat类型,不传sample
          result1 = result1.toLowerCase()
          res = await this.$API.reqResMotifsImg(
            project,
            result1,
            ""
            // page,
            // size
          );
        } else {
          // rice类型，不传type
          res = await this.$API.reqResMotifsImg(
            project,
            "",
            result1
            // page,
            // size
          );
        }
        this.currentImages = res.data || [];
      } catch (error) {
        console.log("Error", error);
        this.currentImages = [];
      }
    },
    handleClick(tab, event) {
      this.loadImages(this.message);
    },
  },
  watch: {
    message: {
      immediate: true,
      handler(newValue) {
        if (newValue === "maize") {
          this.tabs = this.MaizeTabs.map((tab) => ({
            ...tab,
            currentPage: 1,
            totalItems: 100,
          }));
          console.log(this.tabs);
        } else if (newValue === "rice") {
          this.tabs = this.RiceTabs.map((tab) => ({
            ...tab,
            currentPage: 1,
            totalItems: 100,
          }));
        } else if (newValue === "cotton") {
          this.tabs = this.CottonTabs.map((tab) => ({
            ...tab,
            currentPage: 1,
            totalItems: 100,
          }));
        } else if (newValue === "wheat") {
          this.tabs = this.WheatTabs.map((tab) => ({
            ...tab,
            currentPage: 1,
            totalItems: 100,
          }));
        }
        // 重置activeName为当前tabs数组的第一项的name
        if (this.tabs.length > 0) {
          this.activeName = this.tabs[0].name;
          // 可能需要调用loadImages或类似方法来加载与新activeName相关的图片
          this.loadImages(newValue);
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.pic {
  text-align: center; // 保持 h2 文本居中
  h2 {
    font-size: 28px;
    font-weight: bold;
    color: #003164;
    margin: 20px auto;
  }
  .tabs {
    margin: 10px 40px;
    .images {
      .image-section {
        display: flex;
        justify-content: center; // Flex元素整体居中
        flex-wrap: wrap; // 允许图片换行
        .images-wrapper {
          margin: 0 auto;
          margin-bottom: 20px;
          width: 50%;
          overflow: hidden; /* 添加此属性以隐藏溢出的内容 */
          height: 350px; /* 调整为小于图片高度的值以“裁剪”掉底部 */
          position: relative; /* 添加相对定位 */
          .images-wrapper div {
            position: absolute; /* 绝对定位文字 */
            bottom: 10px; /* 距离底部10px，或你想要的任何值 */
            top: 10px;
            left: 0;
            right: 0;
            font-size: 20px;
            color: #fff; /* 文字颜色，确保它在图片上清晰可见 */
            background: rgba(0, 0, 0, 0.5); /* 背景颜色，这样文字更容易阅读 */
            padding: 5px; /* 添加一些内边距 */
          }
          el-image {
            width: 500px;
            height: 500px;
            margin: 30px 30px 10px 30px; /* 顶部、右侧、底部、左侧的外边距 */
          }
        }
      }
    }
  }
}
</style>
